<template>
	<div>
		<el-col :span="5">
			<span style="color:transparent">1 </span>
		</el-col>
		<el-col :span="14">
			<el-card class="box-card" style="margin-top:40px;">
			  <div slot="header" class="clearfix">
			    <span>{{title}}</span>
			  </div>
			  <div ref="msgbox" :style="{ height: `${contentheight}px`, 'overflow-y': 'auto'}">
				  <el-row v-for="(item,index) in msglist" :key="index" style="margin-top:15px;margin-bottom:15px;">
					  <el-col :span="15" v-if="item.type=='sys'">
						  <div class="syscontent" v-if="item.msgtype=='text'">
							<p v-html="item.msg"></p>
							<p v-for="(it,idx) in item.options" style="margin-top:10px">
								<a style="color:#07c05f;cursor:pointer;" @click="sendmsg(it.title)">{{it.title}}</a>
							</p>
						  </div>
						  <div v-else>
								<div class="demo-image__preview" v-if="item.msgtype=='img'">
								  <el-image style="width:150px;height:auto"
									  :src="item.url" 
									  :preview-src-list="item.urllist">
								  </el-image>
								</div>
								<video
								       class="video"
									   v-if="item.msgtype=='video'"
								       controls=""
								       ref="video"
								       id="video"
									   :src="item.video"
								     >
								</video>
						  </div>
					  </el-col>
					  <el-col :span="9" v-if="item.type=='sys'">
						  <span style="color:transparent">1 </span>
					  </el-col>
					  <el-col :span="9" v-if="item.type=='user'">
							<span style="color:transparent">1 </span>
					  </el-col>
					  <el-col :span="15" v-if="item.type=='user'" style="text-align:right;padding-right: 10px;">
					  		<div class="usercontent" v-if="item.msgtype=='text'" v-html="item.msg">
							</div>
							<div v-else>
								<div class="demo-image__preview" v-if="item.msgtype=='img'">
								  <el-image style="width:150px;height:auto"
									  :src="item.url" 
									  :preview-src-list="item.urllist">
								  </el-image>
								</div>
								<video
								       class="video"
									   v-if="item.msgtype=='video'"
								       controls=""
								       ref="video"
								       id="video"
									   :src="item.video"
								     >
								</video>
							</div>
					  </el-col>
				  </el-row>
			  </div>
			  <div class="line" style="height:20px;"></div>
			  <el-row v-if="signature!=''">
				  <el-col :span="1">
					 <el-upload
						ref="uploadimg"
						:multiple="false"
						:limit="1"
					    :action="fileurl"
						accept=".jpeg,.jpg,.png,.gif"
						:on-success="UploadSuccess"
						:on-error="UploadError"
						:on-change="UploadChange"
						:before-upload="UploadBefore"
					    :show-file-list="false">
					    <i class="el-icon-picture-outline" style="font-size:18pt;"></i>
					  </el-upload>
				  </el-col>
				 <el-col :span="16" style="padding-left:10px;">  <!-- :auto-upload="false" -->
					  <el-upload
						ref="uploadvideo"
					    :action="fileurl"
						:multiple="false"
						
						:limit="1"
						accept=".mp4"
						:on-success="UploadSuccess"
						:on-error="UploadError"
						:on-change="UploadChange"
						:before-upload="UploadBefore"
					    :show-file-list="false">
					   <i class="el-icon-film" style="font-size:18pt;"></i>
					  </el-upload>
				  </el-col>
				 <el-col :span="7" style="text-align: right;padding-right:5px;">
					 <el-button type="success" size="small" class="sendbtn" @click="sendmsg()">发送</el-button>
				 </el-col>
			  </el-row>
			  <el-row>
				  <el-col :span="24">
					  <div class="textarea-noborder">
						  <el-input ref="msginput" @keyup.native="val =>enterinput(val)" type="textarea" v-model="msg" rows="4" :disabled="signature==''"></el-input>
					  </div>
				  </el-col>
			  </el-row>
			</el-card>
		</el-col>
	</div>
</template>
<script>
export default {
	data() {
		return {
			contentheight:(window.innerHeight * 48) / 100,
			msglist:[
			// 	{type:'user',msg:'修改的给对方给对方',msgtype:'text'},
			// 	{type:'sys',msg:'发好大风很符合法规',msgtype:'text',options:[{title:'查单号'},{title:'查地址'}]},
			// 	{type:'user',msg:'修改的给对方给对方飞过很飞过很飞过很非共和国和电饭锅电饭锅当个东风给对方郭德纲电饭锅电饭锅电饭锅非官方发护发高鸿股份',msgtype:'text'},
			// 	{type:'sys',msg:'mdf 挂号费fgdfgdfdhfh <a href="https://k.kdfei.cn/">https://k.kdfei.cn/</a>',msgtype:'text'},
			// 	{type:'user',msg:'',msgtype:'img',url:'https://scpic.chinaz.net/files/default/imgs/2023-05-03/944948c45f1c268b.jpg',urllist:['https://scpic.chinaz.net/files/default/imgs/2023-05-03/944948c45f1c268b.jpg']},
			// 	{type:'sys',msg:'',msgtype:'video',video:'https://chatbotassets-75050.gzc.vod.tencent-cloud.com/openaiassets_6c5aebe129a6b6424383887794ca0f48.mp4'}
			 ],
			imuserid:'',
			msg:'',
			signature:'',
			fileurl:'',
			token:'',
			filetype:'',
			filename:this.$tool.getGuid(),
			title:'在线客服'
		};
	},
	mounted() {
		if(this.$route.query!=undefined){
			if(this.$route.query.param!=undefined)
				this.token=this.$route.query.param;
			if(this.$route.query.title!=undefined)
				this.title=this.$route.query.title;	
		}
		//if(this.token!=''){
			this.init();
		//}else
			//this.$tool.message('缺少参数，无法使用',0);
	},
	methods:{
		init(){
			debugger
			this.imuserid=localStorage.getItem('imuserid');
			if(this.imuserid==''||this.imuserid==null)
			{
				this.imuserid=this.$tool.getGuid();
				localStorage.setItem('imuserid',this.imuserid);
			}
			if(this.signature==''){
				this.getsignature();
			}
		},
		getsignature(issend){
			if(issend==undefined)
				issend=false;
			var that=this;
			//debugger
			this.$apipost.post.WxChatGetsignature({userid:this.imuserid,token:this.token }).then(res =>{
				var immsg=localStorage.getItem('Immsg');
				if(immsg!=null){
					if(immsg!=""){
						immsg=JSON.parse(immsg);
						if(immsg.userid==that.imuserid)
						{
							that.msglist=immsg.msglist;
							that.gobottom();
						}
					}
				}
				if(res.signature!=undefined)
				{
					this.$nextTick(function() {
						that.$refs.msginput.focus();
					});
					that.signature=res.signature;
					if(issend)
						that.sendwxchatbot(that.msg);
				}
			});
		},
		sendwxchatbot(msg){
			var that=this;
			if(that.signature==''){
				that.getsignature();
			}else{
				var paraminfo={
					signature:that.signature,
					query:msg
				}
				this.$apipost.post.WxChatSendMsg({paraminfo:paraminfo,token:this.token}).then(res =>{
					if(res.errcode!=undefined){
						if(res.errorcode=='1005')
							that.getsignature(true);
						else
							this.$tool.message('发送失败',0);
					}
					else{
						var options=[];
						if(res.options!=null){
							res.options.forEach(e=>{
								options.push({title:e.title}); 
							});
						}
						if(res.status=='FAQ'){//FAQ
							var answer=JSON.parse(res.answer);
							var msgtext='';
							if(answer.multimsg!=undefined){
								if(answer.multimsg.length>0){
									answer.multimsg.forEach(e=>{
										msgtext+=e+'<br />';
									});
								}
								that.addmsgtolist({type:'sys',msg:msgtext,msgtype:'text'});
							}
							else{
								if(answer.image!=undefined)
									that.addmsgtolist({type:'sys',msg:'',url:answer.image.url,urllist:[answer.image.url],msgtype:'img'});
								if(answer.video!=undefined)
									that.addmsgtolist({type:'sys',msg:'',video:answer.video.url,msgtype:'video'});
							}
						}
						else
							that.addmsgtolist({type:'sys',msg:res.answer,msgtype:'text',options:options});
					}
					
				});
			}
		},
		sendmsg(msg){
			var sendmsg='';
			if(msg!=undefined)
				sendmsg=msg;
			else
				sendmsg=this.msg;
			sendmsg=sendmsg.trim().replace(/\n/g,'');
			if(sendmsg!=''){
				this.addmsgtolist({type:'user',msg:sendmsg,msgtype:'text'});
				this.msg='';
				this.sendwxchatbot(sendmsg);
			}
		},
		enterinput(event){
			if (event.keyCode != undefined) {
				if (event.keyCode == 13) {
					this.sendmsg();
				}
			}
		},
		addmsgtolist(msginfo){
			this.msglist.push(msginfo);
			var msg={
				token:this.token,
				userid:this.imuserid,
				msglist:this.msglist
			}
			localStorage.setItem('Immsg',JSON.stringify(msg));
			this.gobottom();
		},
		gobottom(){
			this.$nextTick(() => {
				this.$refs.msgbox.scrollTop = this.$refs.msgbox.scrollHeight;
			});
		},
		UploadSuccess(res, file, fileList) {
			if(res.state=='1'){
				//调用发送方法
				var fileurl=decodeURIComponent(res.filename);
				var msgtype='img';
				var msginfo={};
				if(this.filetype=='.mp4'){
					msginfo={
						video:{
							url:fileurl
						}
					}
					this.msglist.push({type:'user',msg:'',video:fileurl,msgtype:'video'});
				}
				else{
					msginfo={
						image:{
							url:fileurl
						}
					}
					this.msglist.push({type:'user',msg:'',url:fileurl,urllist:[fileurl],msgtype:'img'});
				}
				this.sendwxchatbot(JSON.stringify(msginfo));
				
				if(this.filetype=='.mp4'){
					if(this.$refs.uploadvideo!=undefined)
						this.$refs.upload.clearFiles();
					else{
						if(this.$refs.uploadvideo.length>0)
							this.$refs.uploadvideo[0].clearFiles();
					}
				}
				else{
					if(this.$refs.uploadimg!=undefined)
						this.$refs.uploadimg.clearFiles();
					else{
						if(this.$refs.uploadimg.length>0)
							this.$refs.uploadimg[0].clearFiles();
					}
				}
				this.filetype='';
			}
		},
		UploadError(err, file, fileList) {
			console.log('上传错误 error', err);
		},
		UploadChange(file, fileList) {
			//debugger
			if(this.filetype==''){
				this.$tool.message('正在发送');
			}
			if(fileList.length>0){
				var filetype=file.name.substring(file.name.lastIndexOf('.'),file.name.length);
				this.filetype=filetype;
				return new Promise((resolve) => {
				   this.$nextTick(() => {
					 this.fileurl =
						this.$apiprototype.ApiServer +
						'/File/UploadFileAndReUrl?domain=appcode=YUNBANG&syscode=wxdh&filetype='+filetype+'&filename='+this.$tool.getGuid();
					  
					  resolve();
				   })
				});
			}
		},
		UploadBefore(file){
			//debugger
			var filetype=file.name.substring(file.name.lastIndexOf('.'),file.name.length);
			this.filetype=filetype;
			if(file.size>=1024*1024*10)
			{
				this.$tool.message('上传文件不允许超过10M',0);
				if(filetype=='.mp4')
					this.$refs.uploadvideo.abort();
				else
					this.$refs.uploadimg.abort();
			}
		}
	}
}	
</script>
<style scoped>
html{
	background-color:#000000;
}
body{
	background-color:#b9bdc3;
}
.sendbtn{
	font-size:12pt;
}
.textarea-noborder>>>.el-textarea__inner {
	font-size:11pt;
    border: 0;
    resize: none;/* 这个是去掉 textarea 下面拉伸的那个标志，如下图 */
  }
.syscontent{
	width:auto; 
	display:inline-block !important; 
	display:inline;
	border-radius:4px;
	padding:8px;
	font-size:9pt;
	background-color:#eff5fe;
	color:#7a7d82;
}
.usercontent{
	width:auto; 
	display:inline-block !important; 
	display:inline;
	border-radius:4px;
	padding:8px;
	font-size:9pt;
	background-color:#07c05f;
	color:#ffffff;
}
.line{
	border-bottom:1px solid #e2e2e2;
	margin-top:5px;
	margin-bottom: 5px;
}
.video {
    width: 18.9vw;
    height: 25.1vh;
    background: #000;
  }
</style>